<template>
  <div>
    <!-- comments declarations -->
    <div v-if="comments_declarations.length != 0">
      <div class="flex flex-col pb-4">
        <div class="flex flex-col shadow-md bg-gray-100 mb-1 pt-0 p-3">
          <div class="p-2">
            <div class="flex justify-between">
              <h2
                class="text-red text-lg text-bold capitalize mt-2 pb-4 pt-2 border-red-light ml-0"
              >{{ $t("requests.remarques")}}</h2>
              <div class="flex items-center w-auto bg-white pb-4 mr-0 mt-3">
                <sp-button
                  theme="outline-blue"
                  space="small"
                  type="submit"
                  class="justify-end rounded add-comment-btn"
                  @click="showModal()"
                >
                  <i class="fas fa-comment-dots"></i>
                  {{ $t("form.write_comment")}}
                </sp-button>
              </div>
            </div>

            <div v-for="(comment_dec,index) in comments_declarations" :key="index">
              <ul class="comments-timeline">
                <li>
                  <time class="comment-time">
                    <span>{{new Date(comment_dec.created_at)| dateFormat('DD/MM/YYYY HH:mm')}}</span>
                    <!-- <span class="large">{{new Date(comment_dec.created_at)| dateFormat('HH:mm')}}</span> -->
                  </time>
                  <div class="comment-icon">
                    <div v-if="comment_dec.user_id === candidat.id">
                      <i class="icon-message icon-message-candidat fas fa-comment-dots"></i>
                    </div>
                    <div v-else>
                      <i class="icon-message icon-message-responsible fas fa-comment-dots"></i>
                    </div>
                  </div>

                  <div class="flex-wrap comment-content">
                    <div class="flex">
                      <h4
                        v-if="comment_dec.user_id === candidat.id"
                      >{{comment_dec.last_name}} {{comment_dec.name }} &nbsp;</h4>
                      <h4 v-else>{{ $t("team.team_startupact")}} &nbsp;</h4>
                      <p>{{ $t("form.added_comment")}} &nbsp;</p>
                    </div>

                    <blockquote>
                      <p class="blockquote blockquote-primary" v-html="comment_dec.content"></p>
                    </blockquote>
                    <div v-if="comment_dec.document_id">
                      <a :href="comment_dec.path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    <div v-else>
                      <div v-if="comment_dec.document_path">
                      <a :href="comment_dec.document_path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

 
    <h1
      class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
    >{{ $t('declarations.detail_declaration') }}</h1>

     <div
      v-if="comments_declarations.length == 0"
      class="flex items-center justify-end w-auto bg-white mx-0"
    >
      <sp-button
        theme="outline-blue"
        space="small"
        type="submit"
        class="justify-end rounded add-comment-btn"
        @click="showModal()"
      >
        <i class="fas fa-comment-dots"></i>
        {{ $t("form.write_comment")}}
      </sp-button>
    </div>

    <!-- Modal add comment declaration -->
    
    <commentDeclaration @add-comment="onClickCommentDeclaration" />

    <div v-if="details">
      <div class="flex flex-col mt-8">
        <div class="flex flex-col shadow-md bg-gray-100 mb-3 p-3">
          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t("requests.name_project") }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <span v-if="details.project_name">{{details.project_name}}</span>
            </div>
          </div>
 
          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t("declarations.declaration_type") }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <span v-if="details.formName">{{ details.formName }}</span>
            </div>
          </div>
          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t("declarations.status") }} :</div>
            <div class="flex-1 px-4 py-2 m-2 font-semibold text-red">
              <span v-if="details.status == 0">{{$t("requests.new_request")}}</span>
              <span v-if="details.status == 1">{{$t("requests.pending_request")}}</span>
              <span v-if="details.status == 2">{{$t("requests.accepted_request")}}</span>
              <span v-if="details.status == 3">{{$t("requests.refused_request")}}</span>
              <span v-if="details.status == 4">{{$t("requests.invalid_request")}}</span>
              <span v-if="details.status == 5">{{$t("requests.sotugar_request")}}</span>
            </div>
          </div>

          <div class="inline-flex">
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.submitted') }} :</div>
            <div
              class="flex-1 px-4 py-2 m-2"
            >{{new Date(details.created_at)| dateFormat('DD/MM/YYYY')}}</div>
          </div>
          <div
            class="inline-flex"
            v-if="details.sotugar_decision"
          >
            <div class="flex-1 px-4 py-2 m-2">{{ $t('requests.decision_sotugar') }} :</div>
            <div class="flex-1 px-4 py-2 m-2">
              <a
                :href="details.sotugar_decision"
                target="_blank"
                class="font-semibold text-red"
              >{{ $t('requests.decision_sotugar') }}</a>
            </div>
          </div>
        </div>
        <br />
        <div class="inline-flex">
          <div
            class="flex-1 text-lg mb-1 border-red-light font-semibold text-red"
          >{{ $t("requests.detail_question") }}</div>
        </div>
        <form autocomplete="off" name="formrequest" v-if="responses_questions">
          <div v-for="(q, index) in responses_questions" :key="index">
            <div v-if="startupNames && (codeName == 'DECLARATION_DE_REALISATION' || codeName == 'DECLARATION_DE_REALISATION levée de fonds') && (q.response_type == 31 || q.response_type == 10)">
              <q-form
                :question="{
                  ...q,
                  options: startupNames,
                  option: startupNames
                }"
                :responses="responses"
                :started="true"
                @update-disabled="updateDisabled"
                @data-emitted="handleDataFromChild"
                :data-to-pass="dataFromChild"
                :showError="showError"
                :requestFormShow="true"
                :disabled="true"
                :labelDate="session && session.startup_application && session.startup_application.label_created_at"
                :formType="codeName"
              ></q-form>
            </div>
            <div v-else-if="['INVESTOR_GUARANTEE_FORM', 'INVESTOR_CALL_GUARANTEE_FORM'].includes(codeName) && q.response_type == 31 && ['section', 'division', 'groupe', 'classe'].includes(q.tag)">
              <q-form
                :question="{ ...q, options: getOptions(q.tag), option: getOptions(q.tag) }"
                :responses="responses"
                :formType="codeName"
                :started="true"
                :showError="showError"
                :requestFormShow="true"
                :disabled="true"
                :sections="sections"
                :divisions="relatedDivisions"
                :groups="relatedGroups"
                :classes="relatedClasses"
                @relatedDivisions="handleRelatedDivisions"
                @relatedGroups="handleRelatedGroups"
                @relatedClasses="handleRelatedClasses"
                @selectedDivision="handleSelectedDivisions"
                @selectedGroup="handleSelectedGroups"
              ></q-form>
          </div>
            <div v-else>
              <q-form
                :question="q"
                :started="true"
                @update-disabled="updateDisabled"
                :showError="showError"
                :requestFormShow="true"
                :responses="responses"
                :disabled="true"
                :labelDate="session && session.startup_application && session.startup_application.label_created_at"
              ></q-form>
            </div>
            
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<style scoped>
table.border-separate {
  border-spacing: 0 10px;
}

table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}

table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}

.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}
.loader {
  margin: 0 0 2em;
  height: 100px;
  width: 80%;
  text-align: center;
  padding: 1em;
  margin: 0 auto 1em;
  display: inline-block;
  vertical-align: top;
}

/*
  Set the color of the icon
*/

.loader svg path,
.loader svg rect {
  fill: #ff6700;
}

.bg-doc {
  background-repeat: no-repeat;
  background-size: 50px 49px;
  height: 50px;
  width: 50px;
}
.px-4[data-v-6f1e2e87][data-v-6f1e2e87][data-v-6f1e2e87] {
  padding-left: 0rem;
}
</style>

<script>
import ApiService from "@/common/api.service";
import { mapGetters, mapState } from "vuex";
import QForm from "@/components/Candidat/QForm.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import {
  SET_LabelApp,
  SET_LabelMenuActive,
  SET_HashId
} from "@/store/mutations.type";
import commentDeclaration from "../Label/commentDeclaration.vue";
import { sections } from "@/common/sectionsData";
export default {
  name: "fromrequest",
  components: {
    "q-form": QForm,
    commentDeclaration: commentDeclaration,
    "sp-button": ButtonVue
  },

  data() {
    return {
      questions: null,
      details: null,
      content: null,
      inProgress: false,
      isSubmitted: false,
      showError: false,
      responses: [],
      responses_questions: [],
      comments_declarations: [],
      startupNames: [],
      codeName: null,
      dataFromChild: '',
      relatedDivisions: [],
      relatedGroups: [],
      relatedClasses: [],
      sections: sections,
      selectedDivision: '',
      selectedGroup: ''
    };
  },
  mounted() {
    this.$store.commit(SET_LabelMenuActive, 1);
    this.showDeclarationRequestByDetail();
  },
  created() {
    this.showDeclarationRequestByDetail();
  },
  methods: {
    getOptions(tag) {
      if (tag === 'section') return this.sections;
      if (tag === 'division') {
        return this.allDivisions;
      }
      if (tag === 'groupe') return this.allGroups;
      if (tag === 'classe') return this.allClasses;
      return [];
    },
    handleRelatedDivisions(data) {
      this.relatedDivisions = data;
    },
    handleRelatedGroups(data) {
      this.relatedGroups = data;
    },
    handleRelatedClasses(data) {
      this.relatedClasses = data;
    },
    handleSelectedDivisions(data) {
      this.selectedDivision = data;
    },
    handleSelectedGroups(data) {
      this.selectedGroup= data;
    },
    handleDataFromChild(data) {
      this.dataFromChild = data;
    },
    onClickCommentDeclaration(comment) {
      var comment_candidat = {
        content: comment[0],
        created_at: new Date(),
        last_name: this.currentUser.last_name,
        name: this.currentUser.name,
        ref_id: this.$route.params.id,
        user_id: this.currentUser.id,
        document_path: comment[1]
      };
      this.comments_declarations.unshift(comment_candidat);
    },
    updateDisabled(val) {
      this.inProgress = val;
      this.isSubmitted = val;
    },
    // Show detail declaration
    showDeclarationRequestByDetail() {
      let appType = this.$route.params.appType;
      let formName = this.$route.params.formName;
      let declarationId = this.$route.params.declarationId;
      let qs = `${appType}/${formName}/${declarationId}`;
      ApiService.get(
        `/api/request/show-detail-declaration/${qs}`
      ).then(data => {
        this.responses_questions = data.data.data.form.questions;
        this.responses_form = data.data.data.form;
        this.details = data.data.data.DecRequest;
        this.comments_declarations = data.data.data.comments;
        this.candidat = data.data.data.user;
        this.startupNames = data.data.data.form.startupNames;
        this.codeName = data.data.data.form.code_name;

      })
      .catch(() => {
        this.$router.push({ name: "home" });
      });
    },
    showModal() {
      this.$modal.show("comment-declaration");
    }
  },

  computed: {
    ...mapGetters(["session", "requestForm", "currentUser", "ecosystemApp"]),
    ...mapState({
      errors: state => state.session.errors
    }),
    allDivisions() {      
      if(this.relatedDivisions) {
        const allDivisions = [];
        this.sections.forEach((section) => {
          allDivisions.push(...section.divisions);
        });
        this.relatedDivisions = allDivisions;
        return this.relatedDivisions;
      }
    },
    allGroups() {
      if(this.relatedGroups) {
        const allGroups = [];
        this.relatedDivisions.forEach((division) => {
          allGroups.push(...division.groups);
        });
        this.relatedGroups = allGroups;
        return this.relatedGroups;
      }
    },
    allClasses() {
      if(this.relatedClasses) {
        const allClasses = [];
        this.relatedGroups.forEach((group) => {
          allClasses.push(...group.classes);
        });
        this.relatedClasses = allClasses;
        return this.relatedClasses;
      }
    }
  }
};
</script>

<style>
.px-4[data-v-6f1e2e87][data-v-6f1e2e87] {
  padding-left: 0rem;
}

@import "../../assets/css/style_comments.scss";
</style>
